import { render } from "./NoteItem.vue?vue&type=template&id=4089f845&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"

import "./NoteItem.vue?vue&type=style&index=0&id=4089f845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4089f845"]])

export default __exports__